import { UserDateAudit } from 'src/app/core/model/user-date-audit';

export class ActivityState extends UserDateAudit{
    id;
	code;
	name;
	color;
}